export default __webpack_public_path__ + "static/Wednesday-5cc3f652991484eabf2d7d2e5f257ee7.png";